import { computed, nextTick, shallowRef, watch} from "vue";
import {defineStore, storeToRefs} from "pinia";
import {useRoute, useRouter} from "vue-router";
import { calcScreenDPI, getHeightForA4Page, isInViewport, throttle } from "../utils/helpers";
import {useBuilder} from "./builder.store";

export const useBuilderToolsStore = defineStore("builder-tools", () => {
    const nrOfPages = shallowRef(1);
    const currentPage = shallowRef(1);
    const route = useRoute();
    
    const builder = useBuilder();
    const { data, loaded } = storeToRefs(builder);

    const calculateNrOfPages = () => {
        const heightPpiInPx = getHeightForA4Page(calcScreenDPI());
        const divHeight = document
            ?.querySelector(".builder-content")
            ?.getBoundingClientRect()?.height || 0;

        nrOfPages.value = Math.ceil(divHeight / heightPpiInPx);
    };

    const scrollToPage = (page) => {
        if (page > nrOfPages.value || page < 1) return;
        document
            .querySelector(".page-" + page)
            .scrollIntoView({ behavior: "smooth" });
        
        setTimeout(() => (currentPage.value = page), 100);
    };

    const pageHeight = computed(() => {
        return getHeightForA4Page(calcScreenDPI());
    });
    
    const checkIfSomePageIsInViewport = () => {
        for (let page = 1; page <= nrOfPages.value; page++) {
            if (isInViewport(document.querySelector(".page-" + page))) {
                currentPage.value = page;
            }
        }
    };
    
    const scrollEventListener = () => {
        document.addEventListener("wheel", () => {
            throttle(checkIfSomePageIsInViewport, 250);
        });
    }
    
    const isOnCoverLetterPage = computed(() => {
       return route?.name?.startsWith("cover-letters")
    })

    watch(data, async (newVal) => {
        if (!loaded.value) return;
        
        await nextTick(() => {
            calculateNrOfPages();
        });
    }, { deep: true })

    watch(loaded, async ( newLoaded ) => {
        if (!newLoaded) return;
        
        await nextTick(() => {
            calculateNrOfPages();
        });
    })

    return {
        nrOfPages,
        currentPage,
        pageHeight,
        isOnCoverLetterPage,
        
        calculateNrOfPages,
        scrollToPage,
        checkIfSomePageIsInViewport,

        scrollEventListener
    }
})
